// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ribbon-col:not(:last-child) .ribbon-group {\n    box-shadow: inset -1px 0 1px rgba(0,0,0,.1);\n}\n\n.ribbon-group-title {\n    background-color: rgba(0,0,0,.1);\n}", ""]);
// Exports
module.exports = exports;
